import { History } from 'history';
import { Route } from 'mk2/containers/Application/Application';
import { hasRoute } from 'mk2/helpers/router';
import { RouterContext } from 'mk2/services/RouterContext';
import React from 'react';
import { LinkProps } from 'react-router-dom'; // tslint:disable-line

type OwnProps = LinkProps;  // inherit from react-router-dom/LinkProps

interface InjectedProps {
    routes: Route[];
    history: History;
}

class LinkWithRoutes extends React.PureComponent<OwnProps & InjectedProps> {

    public static defaultProps = {
        replace: false,
    };

    public render() {
        const { to, replace, innerRef, routes, history, ...rest } = this.props;
        const href = typeof to === 'string' ? to : history.createHref(to);

        return (
            <a
                {...rest}
                onClick={this.onClick}
                href={href}
                ref={innerRef}
            />
        );
    }

    private onClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        const { to, onClick, target, replace, routes, history } = this.props;

        const href = event.currentTarget.href;

        if (onClick) {
            onClick(event);
        }

        if (!event.defaultPrevented // onClick prevent default
            && event.button === 0 // ignore everything but left clicks
            && !target // let browser handle "target=_blank" etc.
            && !isModifiedEvent(event) // ignore clicks with modifier keys
            && hasRoute(href, routes) // Check if we have handler for this URL
        ) {
            event.preventDefault();

            const method = replace ? history.replace : history.push;

            // TODO: This is typescript hack for history.push/replace methods (should be fixed in Typescript 3.x
            if (typeof to === 'string') {
                method(to);
            } else {
                method(to);
            }
        }
    };
}

class Link extends React.PureComponent<OwnProps> {

    public render() {
        return (
            <RouterContext.Consumer>
                {({ routes, history }) => (
                    <LinkWithRoutes {...this.props} routes={routes} history={history}/>
                )}
            </RouterContext.Consumer>
        );
    }
}

export default Link;

function isModifiedEvent(event: React.MouseEvent<HTMLAnchorElement>) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
